import axios from "axios";
import { 
  MY_TASK_PROCESS_LOADING,
  ADD_MY_TASK_LIST,
  ADD_MY_TASK_LIST_FAILED,
  GET_MY_TASK_LIST, 
  UPDATE_MY_TASK_LIST,
  DELETE_MY_TASK_LIST,
  DELETE_MY_TASK_LIST_FAILED,
  GET_MY_TASK_LIST_DETAIL
} from ".";
import { serverUrl } from "../../components/Helpers/Config";
import { tokenAuthorize } from "../../components/Helpers/Common";

export const createMyTask = (title, dueDate, desc, task) => {
  return (dispatch) => {
    dispatch({ type: MY_TASK_PROCESS_LOADING });

    return axios
      .post(serverUrl.LearningMyTask, {
        list_name: title,
        list_due: dueDate,
        list_desc: desc,
        tasks: task,
      })
      .then((resp) => {
        if (resp.status === 200) {
          dispatch({ type: ADD_MY_TASK_LIST, payload: { id: resp.data.id } });
        } else {
          dispatch({ type: ADD_MY_TASK_LIST_FAILED });
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status);
        console.log(error);
        dispatch({ type: ADD_MY_TASK_LIST_FAILED });
      });
  };
};

export const getLearningMyTask = () => {
    return (dispatch) => {
      return axios
        .get(serverUrl.LearningMyTask)
        .then((response) => {
          dispatch({
            type: GET_MY_TASK_LIST,
            payload: response.data.task_list,
          });
          
        })
        .catch((error) => {
          tokenAuthorize(error?.response?.status);
          console.log(error);
        });
    };
  };

  export const updateMyTask = (id, title, dueDate, desc, task) => {
    return (dispatch) => {
      return axios
        .put(serverUrl.LearningMyTask + `/${id}`, {
          list_name: title,
          list_due: dueDate,
          list_desc: desc,
          tasks: task,
        })
        .then(() => {
          dispatch({ type: UPDATE_MY_TASK_LIST });
        })
        .catch((error) => {
          tokenAuthorize(error?.response?.status);
          console.log(error);
        });
    };
  };

  export const deleteLearningMyTask= (id) => {
    return (dispatch) => {
      return axios
        .delete(serverUrl.LearningMyTask + `/${id}`)
        .then((resp) => {
          if (resp.status === 200) {
            dispatch({ type: DELETE_MY_TASK_LIST });
          } else {
            dispatch({ type: DELETE_MY_TASK_LIST_FAILED });
          }
          dispatch(getLearningMyTask());
        })
        .catch((error) => {
          tokenAuthorize(error?.response?.status);
          console.log(error);
        });
    };
  };

